import React from 'react';

import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Desktop/components/AllParamsButton';
import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';

import MileageFilter from './components/MileageFilter';
import PriceFilter from './components/PriceFilter';
import WheelFilter from './components/WheelFilter';
import SpecialFilter from './components/SpecialFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import YearFilter from './components/YearFilter';
import GearboxFilter from './components/GearboxFilter';
import BatteryTypeFilter from './components/BatteryTypeFilter';
import BatteryCapacityFilter from './components/BatteryCapacityFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import EnginePowerFilter from './components/EnginePowerFilter';
import ColorFilter from './components/ColorFilter';
import SeatsFilter from './components/SeatsFilter';
import ClearanceFilter from './components/ClearanceFilter';
import BodyFilter from './components/BodyFilter';

export function ParamsFilterHybrid() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <BodyFilter />
        <WheelFilter />
        <PriceFilter />
        <PowerReserveFilter />
      </FiltersWrapper>

      <AllParamsButton />

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <YearFilter />
          <MileageFilter />
          <GearboxFilter />
          <BatteryTypeFilter />
          <BatteryCapacityFilter />
          <EngineCapacityFilter />
          <EnginePowerFilter />
          <ColorFilter />
          <SeatsFilter />
          <ClearanceFilter />
        </FiltersWrapper>
      </MoreParams>

      <SpecialFilter />
    </React.Fragment>
  );
}
